import { RootUrl } from './root/root-url';
import { SharingModule } from 'src/app/sharing/sharing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CredentialsModule } from './all-modules/credentials/credentials.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataTablesModule } from 'angular-datatables';
import { ToastrModule } from 'ngx-toastr';
import { SpinnerComponent } from './spinner/spinner.component';
import { CommonModule, HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgSelect2Module } from 'ng-select2';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { AuthInterceptor } from './auth/auth.interceptor';



@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    
    

  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DataTablesModule,
    HttpClientModule,
    CredentialsModule,
    CommonModule,
    NgSelect2Module,
    ReactiveFormsModule,
    DropdownModule,
    DialogModule,
    FormsModule,
    
    ToastrModule.forRoot(
      {
        timeOut: 1500,
        positionClass: 'toast-bottom-right',
        preventDuplicates: true,
      }
    ),
  ],
  providers: [RootUrl,
    //{ provide: LocationStrategy, useClass: HashLocationStrategy },
    {provide:LocationStrategy,useClass:PathLocationStrategy},
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
